import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../../models/user';
import { CrudService } from '../crud.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService extends CrudService<User> {
  protected basePath = 'user'; // Specific for UserService
  public instanceType = 'user'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  getItemsByCommune(communeId: string) {
    return lastValueFrom(
      this.http.get<{ [key: string]: User }>(
        `${this.getBaseUrl()}/commune/${communeId}`
      )
    );
  }

  getById(userId: string) {
    return lastValueFrom(this.http.get<User>(`${this.getBaseUrl()}/${userId}`));
  }

  resetPasswordByToken(password: string, token: string) {
    return this.http.put(`${this.getBaseUrl()}/resetPassword/${token}`, {
      password: password,
    });
  }

  resetPassword(password: string, userId: string) {
    return this.http.put(`${this.getBaseUrl()}/changePassword/${userId}`, {
      password: password,
    });
  }

  changeCommune(user: User) {
    console.log('CHANGE USER COMMUNE:', user);
    return this.http
      .put(`${this.getBaseUrl()}/changeCommune/${user._id}`, user)
      .subscribe();
  }
}
